import { useEffect } from "react";
import { api } from "../lib/api";
import { useWorkspace } from "../store/WorkspaceContext";
import { worldPoints } from "../engine/geometry";

// Pre-builds the knife paths for whatever sits on the roll (debounced), so pressing Cut compiles instantly.
export function useCutWarmup() {
  const { state } = useWorkspace();
  const included = state.pieces.filter((p) => p.included);
  const key = included.map((p) => `${p.id}:${p.rotation}:${p.points?.length}:${p.edited ? 1 : 0}:${p.version}`).join("|");
  useEffect(() => {
    if (!included.length) return undefined;
    const t = setTimeout(() => {
      const outlines = included.map((p) => worldPoints(p).map(([x, y]) => [+x.toFixed(4), +y.toFixed(4)]));
      api.warmCut(outlines).catch(() => {});
    }, 600);
    return () => clearTimeout(t);
  }, [key]); // eslint-disable-line react-hooks/exhaustive-deps
}
